import config from 'config';

export const ASSETS = {
  settingUpLinkOwnership: `${config.PUBLIC_URL}/assets/setting-up-link-ownership.mov`,
  onboardingVideo: `${config.PUBLIC_URL}/assets/onboarding-video.mp4`,
  howToEditFBLinkOwnership:
    'https://www.facebook.com/business/help/321167023127050',
  lnkBioKontentino: `https://lnk.bio/kontentino`,
};
